var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmbedStatic = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.6533 2.00781C14.4097 2.08461 15 2.72334 15 3.5V12.5C15 13.2767 14.4097 13.9154 13.6533 13.9922L13.5 14H2.5C1.67157 14 1 13.3284 1 12.5V3.5C1 2.67157 1.67157 2 2.5 2H13.5L13.6533 2.00781ZM6 12.5H13.5V7H6V12.5ZM2.5 12.5H4.5V7H2.5V12.5ZM2.5 5.5H13.5V3.5H2.5V5.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmbedStatic);
export default ForwardRef;